import React, { Component } from 'react';

import flatMap from 'lodash/flatMap';
import forEach from 'lodash/forEach';

import FixedSelect from 'components/forms/components/fixed-option-select';
import FormSelectGroup from 'components/forms/components/form-select-group';
import { PaddingWrapper } from 'components/styled-components';

class EditAssessment extends Component {
  state = {};

  componentDidMount() {
    const { instance } = this.props;
    forEach(instance, i => {
      const answers = i.answers
        .filter(a => a.selected)
        .map(a => ({ ...a, isFixed: true }));
      this.setState({ [i.questionID]: answers });
    });
  }

  appendIsFixed = answers =>
    answers.map(answer =>
      answer.selected ? { ...answer, isFixed: true } : answer
    );

  handleUpdateAnswers = (values, questionID) => {
    this.setState({ [questionID]: values }, () => {
      const { mappedFixedAnswers, ...answers } = this.state;
      const answerIDs = flatMap(answers, answer => {
        return answer.map(a => a.answerID).filter(a => a);
      });
      this.props.shareValuesWithParent(answerIDs);
    });
  };
  render() {
    const { instance } = this.props;
    return (
      <PaddingWrapper padding="2rem">
        {instance.map((question, i) => {
          return (
            <FormSelectGroup
              key={i}
              value={this.state[question.questionID] ? this.state[question.questionID] : []}
            //   handleUpdateAnswers={this.handleUpdateAnswers}
              onChange={(a, selected) => this.handleUpdateAnswers(selected, question.questionID)}
              question={question}
            //   options={this.appendIsFixed(question.answers)}
			  asyncOptions={question.answers}
			  multi={true}
			  labelKey={"answer"}
			  valueKey={"answerID"}
            />
          );
        })}
      </PaddingWrapper>
    );
  }
}

export default EditAssessment;
